import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState } from "react";
import BlockHeader from "../../../../component/BlockHeader/BlockHeader";
import ContinueCreateInitiative from "../../../../component/ContinueCreate";
import mapState from "../../../../store/stateMap";
import api from '../../../../api';
import { createSearchParams, Link, useSearchParams, useNavigate } from "react-router-dom";
import { popinfo } from '../../../../component/Fancybox/Fancybox';
import {ReactComponent as SVGleft} from '../../../../assets/arrow-left-3.svg';
import "../style.scss";
import "./style.scss";
import LoginBox from 'component/LoginBox/LoginBox';
import { PageCredential } from 'component/PageCredential';


export default connect(mapState)((props) => {
    const[selectedType, setSelectedType] = useState(false);
    const[continuedInitiative, setContinuedInitiative] = useState(false);
    const[formDataLoad, setFormDataLoad] = useState(true);
    let navigate        = useNavigate();
    let [searchParams]  = useSearchParams();

    const NextPage = (e) => {
        e.preventDefault();

        if(!selectedType)
        {
            popinfo('error', 'Oopss', 'Please choose your initiative type first');
        }
        else
        {
            navigate({
                pathname : '../describe'
                ,search : `${createSearchParams({
                    type : selectedType
                })}`
            });
        }
    }

    useEffect(() =>{

        if(props.auth.user === false)
        {
            return;
        }
        if(searchParams.get('id') > 0)
        {
            api('/Initiative','get', {
                id : searchParams.get('id')
            }, 'Bearer ' + props.auth.token)
            .then((response) => {
                
                if(response.initiative[0].InitiatorID == props.auth.user.UserID)
                {
                    setContinuedInitiative(response.initiative[0]);
                }

                setFormDataLoad(false);
            })
        }
        else
        {
            setFormDataLoad(false);
        }
    }, [props.auth.user]);

    return(
        <>
            <PageCredential title="Select Initiative Type"/>
            {
                props.auth.user ?
                <div id="page-create-initiative-select" className="container w-800 relative">
                    <span className="registration-back">
                        {
                            !formDataLoad &&
                            <Link to={{
                                pathname : '/create'
                                ,search : `?${createSearchParams({
                                    id : typeof continuedInitiative.InitiativeID != 'undefined' ? continuedInitiative.InitiativeID : 0
                                })}`
                            }}><SVGleft/> Back</Link>
                        }
                    </span>
                    <div className="text-center">
                        <span className="block text-xs mb-5">2 of {['talent', 'other'].indexOf(selectedType) >= 0 ? '3' : '4' } </span>
                        <BlockHeader title="First, let’s get you set up." desc="Pick a initiative category to connect with a specific community." />
                    </div>
                    <div className="mt-5 mb-4">
                        <ul className="action-options">
                            <li className={"action-option " + (selectedType == 'research' ? 'selected color-research' : '') }>
                                <div className="wrapper rounded">
                                    <h2 className="action-title">Research Activity</h2>
                                    <div className="leading-text text-xs">Start to collaborate with people from similar or other disciplines. Collaborative research will help you to exchange ideas and create a higher research quality.</div>
                                    <div className="text-center mt-md btn-wrapper">
                                        <button className="btn btn-orange btn-small" onClick={()=>{setSelectedType('research')}}>Choose</button>
                                    </div>
                                </div>
                            </li>
                            <li className={"action-option " + (selectedType == 'event' ? 'selected color-event' : '') }>
                                <div className="wrapper rounded">
                                    <h2 className="action-title">Event</h2>
                                    <div className="leading-text text-xs">Are you looking for visitors for your event, or Hire qualified people to handle your event. Find the roles you need to help you execute your event. The right crews will make your event go beyond success.</div>
                                    <div className="text-center mt-md btn-wrapper">
                                        <button className="btn btn-orange btn-small" onClick={()=>{setSelectedType('event')}}>Choose</button>
                                    </div>
                                </div>
                            </li>
                            <li className={"action-option " + (selectedType == 'talent' ? 'selected color-talent' : '') }>
                                <div className="wrapper rounded">
                                    <h2 className="action-title">Talent Team</h2>
                                    <div className="leading-text text-xs">Build your dream team by finding the right talent for your project. Choose the talent that suitable with your needs based on their relevant qualifications, skills, and expertise.</div>
                                    <div className="text-center mt-md btn-wrapper">
                                        <button className="btn btn-orange btn-small" onClick={()=>{setSelectedType('talent')}}>Choose</button>
                                    </div>
                                </div>
                            </li>
                            <li className={"action-option " + (selectedType == 'other' ? 'selected color-other' : '') }>
                                <div className="wrapper rounded">
                                    <h2 className="action-title">Other</h2>
                                    <div className="leading-text text-xs">If you can't find any suitable categories. Find out the partner, talent, or staff you needs here.</div>
                                    <div className="text-center mt-md btn-wrapper">
                                        <button className="btn btn-orange btn-small" onClick={()=>{setSelectedType('other')}}>Choose</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {
                        formDataLoad ? <span className="skeleton"></span> : 
                        <div className="form-actions">
                            {
                                continuedInitiative ? 
                                <Fragment>
                                    <div  >
                                        <button className="btn btn-orange btn-reverse" onClick={NextPage}>Start Over</button>
                                    </div> 
                                    <div className="text-right">
                                        <ContinueCreateInitiative className="btn btn-orange" sentInitiative={continuedInitiative} />
                                    </div>
                                </Fragment>
                                : 
                                <Fragment>
                                    <div>
                                        <ContinueCreateInitiative className="btn btn-orange btn-reverse" sentInitiative={continuedInitiative} />
                                    </div>
                                    <div className="text-right" >
                                        <button className="btn btn-orange" onClick={NextPage}>Next : Detail Initiative</button>
                                    </div>
                                </Fragment>
                            }
                        </div>
                    }
        
        
                </div> : 
                <LoginBox/>
            }
        </>
    )
});